import { loadAcalogAPI } from "../acalogAPI";
import { setLocalStorageWithExpiry, getLocalStorageWithExpiry } from "../../../helpers/localStorage";

const API_KEY = '77f07c6a693c4db31e55465a3a4f5a7d27deb458';
const CATALOGS_STORAGE_KEY = 'sp451_acalog_catalogs';
const CATALOGS_TTL_MS = 3 * 24 * 60 * 60 * 1000;

function fetchCatalogs() {
  let cachedCatalogs = getLocalStorageWithExpiry(CATALOGS_STORAGE_KEY);
  if (cachedCatalogs && Array.isArray(cachedCatalogs) && cachedCatalogs.length) {
    return Promise.resolve(cachedCatalogs);
  }

  const catalogsUrl = `https://sunywcc.apis.acalog.com/v1/content?key=${API_KEY}&format=xml&method=getCatalogs`;

  return fetch(catalogsUrl)
    .then((res) => {
      if (!res.ok) throw new Error('Failed to fetch catalogs');
      return res.text();
    })
    .then((xmlStr) => {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(xmlStr, 'application/xml');

      const catalogs = Array.from(xmlDoc.getElementsByTagName('catalog'))
        .filter((catalog) => {
          const publishedNode = catalog.querySelector('state > published');
          const archivedNode = catalog.querySelector('state > archived');
          return (
            publishedNode &&
            archivedNode &&
            publishedNode.textContent.trim().toLowerCase() === 'yes' &&
            archivedNode.textContent.trim().toLowerCase() === 'no'
          );
        })
        .map((catalog) => {
          const idAttr = catalog.getAttribute('id') || '';
          const match = idAttr.match(/acalog-catalog-(\d+)/);
          return match ? Number(match[1]) : null;
        })
        .filter(Boolean)
        .sort((a, b) => b - a);

      setLocalStorageWithExpiry(CATALOGS_STORAGE_KEY, catalogs, CATALOGS_TTL_MS);

      return catalogs;
    });
}

function processOverview(module, mapContainer) {
  let overviewTitle = mapContainer.find('h2.acalog-program-core-name:contains("Program Description")').first();

  if (!overviewTitle.length) {
    return;
  }

  let descriptionContainer = overviewTitle.next(".acalog-program-core-description");

  if (!descriptionContainer.length) {
    return;
  }

  let overviewDataContainer = module.find(".js-overviewContainer");
  overviewDataContainer.html(descriptionContainer.html());
}

function processAosOverview(module, mapContainer) {
  let overviewDataContainer = module.find(".js-overviewContainer");
  overviewDataContainer.html(mapContainer);
}

function fetchWithTimeout(url, options = {}, timeout = 5000) { // 5 seconds timeout default
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new Error('Fetch timed out'));
    }, timeout);

    options.headers = {
      ...options.headers,
      'Access-Control-Allow-Origin': window.location.origin
    };

    fetch(url, options)
      .then((response) => {
        clearTimeout(timer);
        resolve(response);
      })
      .catch((err) => {
        clearTimeout(timer);
        reject(err);
      });
  });
}

function fetchProgramInCatalog(programName, catalogId) {
  const query = encodeURIComponent(programName);
  const url = `https://sunywcc.apis.acalog.com/v1/search/programs?key=${API_KEY}&format=xml&method=search&catalog=${catalogId}&query=${query}`;

  return fetchWithTimeout(url, {}, 5000)  // 5 sec timeout
    .then((res) => {
      if (!res.ok) throw new Error(`Failed to fetch programs for catalog ${catalogId}`);
      return res.text();
    })
    .then((xmlStr) => {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(xmlStr, 'application/xml');

      const results = xmlDoc.getElementsByTagName('result');
      for (let i = 0; i < results.length; i++) {
        const nameNode = results[i].getElementsByTagName('name')[0];
        if (!nameNode) continue;
        if (nameNode.textContent.trim() === programName) {
          const idNode = results[i].getElementsByTagName('id')[0];
          if (!idNode) continue;
          return {
            catalogId,
            programId: idNode.textContent.trim(),
          };
        }
      }
      // no match found
      return null;
    });
}

function findProgramAcrossCatalogs(programName, catalogs) {
  let idx = 0;

  return new Promise((resolve, reject) => {
    function tryNext() {
      if (idx >= catalogs.length) {
        resolve(null);
        return;
      }
      const catalogId = catalogs[idx++];
      fetchProgramInCatalog(programName, catalogId)
        .then((res) => {
          if (res) {
            resolve(res);
          } else {
            tryNext();
          }
        })
        .catch(() => {
          // ignore errors, try next catalog
          tryNext();
        });
    }
    tryNext();
  });
}

function fetchApiGoToProgram(programName, programBtn) {
  if (!window.__openCatalogPrograms) {
    console.warn('Open catalog programs mode disabled');
    return;
  }

  // There is already hard coded URL in backend
  if (programBtn.hasClass('no-ajax')) {
    return;
  }

  fetchCatalogs()
    .then((catalogs) => {
      if (!catalogs || catalogs.length === 0) {
        console.error('No active catalogs found');
        return;
      }

      return findProgramAcrossCatalogs(programName, catalogs);
    })
    .then((result) => {
      if (!result) {
        console.log('Program not found in any catalog');
        return;
      }

      const { catalogId, programId } = result;
      const previewUrl = `https://catalog.sunywcc.edu/preview_program.php?catoid=${catalogId}&poid=${programId}`;

      programBtn.attr('href', previewUrl);
      programBtn.attr('target', '_blank');
    })
    .catch((err) => {
      console.error('Error searching program:', err);
    });
}

function doACALogAPI($module, type = 'program') {
  var calledFetch = false;

  if (typeof window.$ === "undefined" && typeof window.jQuery !== "undefined") {
    window.$ = window.jQuery;
  }

  var programBtn = $module.find('.js-overviewContainer + a.btn');
  let programName = $module.data('program-name');

  if ($module.hasClass('-active')) return;

  // Program Data
  if (type === 'program') {
    $(function () {
      var acalog = $module.find(".acalog.js-hideAcalog");
      var container = $module.find('.js-overviewContainer');

      if (!acalog.length) {
        return;
      }

      const hasHtml = container.children().length > 0;
      const textLength = $.trim(container.text()).length;

      if (hasHtml || textLength > 20) {
        return false;
      }

      acalog.hide();
      acalog.acalogWidgetize({ gateway: "https://catalog.sunywcc.edu" });

      var checkAcalogLoaded = setInterval(function () {
        let acalog = $module.find(".acalog.js-hideAcalog");

        if (!acalog.length) {
          return;
        }

        let sections = [
          { handler: processOverview, searchFor: 'h2.acalog-program-core-name:contains("Program Description")' }
        ];

        let foundSections = 0;

        sections.forEach(({ handler, searchFor }) => {
          let module = $module[0];

          if (!module) return;

          let sectionTitle = acalog.find(searchFor).first();
          if (!sectionTitle.length) {
            return;
          }

          let mapContainer = sectionTitle.closest(".acalog-program-core");

          if (!mapContainer) {
            return;
          }

          handler($module, mapContainer);
          foundSections++;
        });

        if (!calledFetch) {
          calledFetch = true;
          fetchApiGoToProgram(programName, programBtn);
        }

        if (foundSections > 0) {
          clearInterval(checkAcalogLoaded);
        }
      }, 500);
    });
  }
  else {
    // AOS Data
    $(function () {
      var acalog = $module.find(".acalog.js-hideAcalog");
      var container = $module.find('.js-overviewContainer');

      const hasHtml = container.children().length > 0;
      const textLength = $.trim(container.text()).length;

      if (hasHtml || textLength > 20) {
        return false;
      }

      if (!acalog.length) {
        // console.error("No .acalog div found!");
        return;
      }

      let programName = acalog.data('acalog-program-name');

      if (!programName) return;

      acalog.hide();
      acalog.acalogWidgetize({
        gateway: "https://catalog.sunywcc.edu",
        data: 'programs',
        catalogFilter: 'x',
        programName
      });

      var checkAcalogLoaded = setInterval(function () {
        let acalog = $module.find(".acalog.js-hideAcalog");

        if (!acalog.length) {
          return;
        }

        let sections = [
          { handler: processAosOverview, searchFor: 'div.acalog-program-description', searchFor2: 'div.acalog-program-core-description' }
        ];

        let foundSections = 0;

        sections.forEach(({ handler, searchFor, searchFor2 }) => {
          let module = $module[0];

          if (!module) return;

          let sectionFound = acalog.find(searchFor).first();

          if (!sectionFound.length || !sectionFound[0].innerHTML || !$(searchFor).children().length > 0) {
            sectionFound = acalog.find(searchFor2).first();

            if (!sectionFound.length)
              return;
          }

          let mapContainer = sectionFound;

          if (!mapContainer) {
            return;
          }

          handler($module, mapContainer);
          foundSections++;
        });

        if (!calledFetch) {
          calledFetch = true;
          fetchApiGoToProgram(programName, programBtn);
        }

        if (foundSections > 0) {
          clearInterval(checkAcalogLoaded);
        }
      }, 500);
    });
  }
}

export function overviewInProgramFinder() {
  let apiClickablePrograms = $('.js-soloProgramFetchOverview');

  apiClickablePrograms.click(function (e) {
    let _this = $(this);
    let type = _this.data('program-type');

    doACALogAPI(_this, type);
  });
}